"use client";

import { c as _c } from "react/compiler-runtime";
import { AddCircleIcon, CheckmarkCircle02Icon, InformationCircleIcon, Share01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Item, ItemContent, ItemDescription, ItemGroup, ItemMedia, ItemTitle } from "@/components/ui/item";
import { Separator } from "@/components/ui/separator";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};
export function IOSInstallSheet(t0) {
  const $ = _c(7);
  const {
    open,
    onOpenChange
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SheetHeader className="gap-3 pb-4"><div className="space-y-1"><SheetTitle className="font-semibold text-xl">Install Clutch on iPhone</SheetTitle><SheetDescription>Install from Safari in three steps.</SheetDescription></div></SheetHeader>;
    t2 = <Separator className="bg-border/70" />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="px-6 py-6"><ItemGroup><Step icon={Share01Icon} title="Tap the Share button" body="Look for the square with an upward arrow in Safari, usually in the bottom toolbar." /><Step icon={AddCircleIcon} title={"Choose \"Add to Home Screen\""} body="Scroll through the share sheet if that action is not visible right away." /><Step icon={CheckmarkCircle02Icon} title={"Tap \"Add\""} body="Clutch will appear on your home screen and launch like an installed app." /></ItemGroup></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SheetContent side="bottom" className="max-h-[85vh] overflow-y-auto rounded-t-4xl">{t1}{t2}{t3}<div className="px-6 pb-6"><Alert className="border-border/70 bg-muted/40"><HugeiconsIcon icon={InformationCircleIcon} size={16} /><AlertTitle>Not seeing the Share button?</AlertTitle><AlertDescription>Use Safari. In-app browsers and Chrome on iOS cannot install Clutch the same way.</AlertDescription></Alert></div></SheetContent>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onOpenChange || $[5] !== open) {
    t5 = <Sheet open={open} onOpenChange={onOpenChange}>{t4}</Sheet>;
    $[4] = onOpenChange;
    $[5] = open;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}
function Step(t0) {
  const $ = _c(12);
  const {
    icon,
    title,
    body
  } = t0;
  let t1;
  if ($[0] !== icon) {
    t1 = <ItemMedia className="mt-0.5"><div className="flex size-9 items-center justify-center rounded-full bg-primary/10 text-primary"><HugeiconsIcon icon={icon} size={18} /></div></ItemMedia>;
    $[0] = icon;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title) {
    t2 = <ItemTitle className="text-sm">{title}</ItemTitle>;
    $[2] = title;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== body) {
    t3 = <ItemDescription>{body}</ItemDescription>;
    $[4] = body;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <ItemContent>{t2}{t3}</ItemContent>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <Item variant="outline" size="sm" className="items-start rounded-3xl">{t1}{t4}</Item>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}